import React from 'react'
import { Link } from 'react-router'
import DashboardIcon from '../../img/icons/general-icons/icon_dashboard.png'

export default class LinkDashboard extends React.Component {
  render () {
    var url = 'estadoSaludDashboard/' + this.props.numeroDocumento
    return (
      <Link to={url}><img src={DashboardIcon}/></Link>
    )
  }
}

/* Validate Props */
LinkDashboard.propTypes = {
  rowData: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Search/LinkImageDashboard.js